import {
  ClassNameMap,
  TypographyClasses,
  TypographyProps,
} from "@mui/material";
import { HTMLAttributes, useEffect, useState } from "react";
import "../../components/phoneLibrary/phoneLibrary.css";
import { EMPTY_VALUE_DASH } from "../../helpers/constants";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { isEmpty } from "../../helpers/utils";
import PhoneInput from "../phoneLibrary";
import { MuiTypography } from "../typography/MuiTypography";
import { MuiDoubleLabelWithFormattedPhoneTextWrapper } from "./MuiDoubleLabelWithFormattedPhoneText.style";

interface MuiDoubleLabelWithFormattedPhoneTextProps
  extends HTMLAttributes<HTMLDivElement> {
  label: string;
  selectedCountry: string;
  phoneNumber: string;
  countryCode: string;
  isViewOnly?: boolean;
  showWithFormat?: boolean;
  replaceEmptyWithDash?: boolean;
  labelTypoVariant?: TypographyProps["variant"];
  valueTypoVariant?: TypographyProps["variant"];
  labelClasses?: Partial<TypographyClasses> & Partial<ClassNameMap<never>>;
  valueClasses?: Partial<TypographyClasses> & Partial<ClassNameMap<never>>;
}

export const MuiDoubleLabelWithFormattedPhoneText: React.FC<
  MuiDoubleLabelWithFormattedPhoneTextProps
> = ({
  label,
  phoneNumber,
  selectedCountry,
  countryCode,
  isViewOnly = true,
  replaceEmptyWithDash = false,
  labelTypoVariant = "h3",
  valueTypoVariant = "h4Bold",
  labelClasses,
  valueClasses,
  showWithFormat = false,
  ...rest
}) => {
  const [phoneValue, setPhoneValue] = useState("");

  useEffect(() => {
    if (phoneNumber) {
      setPhoneValue(phoneNumber);
    }
  }, [phoneNumber]);

  return (
    <MuiDoubleLabelWithFormattedPhoneTextWrapper {...rest}>
      {label && (
        <MuiTypography
          className={"mui-label"}
          component="label"
          variant={labelTypoVariant}
          classes={labelClasses}
        >
          {label}
        </MuiTypography>
      )}
      {replaceEmptyWithDash &&
      isEmpty(phoneValue) &&
      isEmpty(countryCode) &&
      isEmpty(selectedCountry) ? (
        <MuiTypography
          component={"h4"}
          data-testid={COMPONENT_IDS.COMMON_DOUBLE_LABEL_VALUE}
          className={`value-style ${valueClasses}`}
          variant={valueTypoVariant}
          classes={valueClasses}
        >
          {EMPTY_VALUE_DASH}
        </MuiTypography>
      ) : (
        <MuiTypography
          component={"h4"}
          data-testid={COMPONENT_IDS.COMMON_DOUBLE_LABEL_VALUE}
          className={`value-style ${valueClasses}`}
          variant={valueTypoVariant}
          classes={valueClasses}
        >
          {showWithFormat ? (
            <>
              {countryCode}{" "}
              <PhoneInput
                value={phoneValue}
                isViewOnly={isViewOnly}
                country={selectedCountry}
                disableCountryGuess
                disableCountryCode
                clearValue={true}
              />
            </>
          ) : (
            [countryCode, phoneValue].filter(Boolean).join(" ")
          )}
        </MuiTypography>
      )}
    </MuiDoubleLabelWithFormattedPhoneTextWrapper>
  );
};
